import { Button } from '@neo/primitives/button'
import { AlertTriangle, ArrowRightLeft } from 'lucide-react'
import { isSubAccountEmbedSession } from 'v2/shared/utils/embed-session'

export const OPEN_MIGRATE_DIALOG_EVENT = 'open-legacy-migrate-dialog'

export const LegacyFlowMigrationBanner = () => {
  const handleMigrate = () => {
    window.dispatchEvent(new CustomEvent(OPEN_MIGRATE_DIALOG_EVENT))
  }

  // The upgrade copies the agent through clone, which hodor refuses to sub-account sessions.
  if (isSubAccountEmbedSession()) return null

  return (
    <div
      className="absolute inset-x-0 top-4 z-50 flex justify-center pointer-events-none"
      data-testid="banner-legacy-flow-migration"
    >
      <div className="pointer-events-auto flex items-center gap-3 rounded-lg border border-status-warning/25 bg-status-warning/[0.08] px-4 py-2.5 shadow-md">
        <AlertTriangle size={16} className="shrink-0 text-status-warning" />
        <span className="text-s-500 text-primary">
          Upgrade to v2 for better agent quality and lower latency
        </span>
        <Button
          size="xs"
          variant="default"
          onClick={handleMigrate}
          data-testid="button-banner-migrate-flow"
        >
          <ArrowRightLeft className="h-3.5 w-3.5 mr-1.5" />
          Upgrade to v2
        </Button>
      </div>
    </div>
  )
}
